import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { listenForInstall } from "./app/install";
import { register as registerServiceWorker } from "./app/serviceWorkerRegistration";
import { DataProvider } from "./data/DataProvider";
import { signedIn } from "./data/account";
import { prefetchHome } from "./data/library";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// A signed-in Home needs its timeline, wants and Continue: fetch them while
// its code-split chunk downloads rather than after.
if (signedIn() && window.location.pathname === "/") {
  prefetchHome();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <DataProvider>
      <App />
    </DataProvider>
  </React.StrictMode>,
);

// Installable PWA: cache the app shell + last-seen API data (ADR 0005).
registerServiceWorker();
// The browser offers to install once, early: catch it before any page asks.
listenForInstall();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
